import { nameText, type WordName } from '../content/names';
import { cleanNickname, cleanNicknames } from '../meta/online/nicknames';
import { saves } from './records';

/** This player's nickname for a player ("LIZA"), or null (src/meta/online/nicknames.ts). */
export function nicknameOf(player: string | undefined): string | null {
  if (!player) return null;
  return cleanNicknames(saves().save.online.nicknames)[player] ?? null;
}

/** Gives a player a nickname, or takes it away ('' or only spaces). Only this player sees it. */
export function setNickname(player: string, raw: string): void {
  const nickname = cleanNickname(raw);
  saves().update((s) => {
    const all = cleanNicknames(s.online.nicknames);
    if (nickname) all[player] = nickname;
    else delete all[player];
    if (Object.keys(all).length > 0) s.online.nicknames = all;
    else delete s.online.nicknames;
  });
}

/** How a player reads for this player: their nickname if they have one, else their name. */
export function whoText(player: string | undefined, name: WordName): string {
  return nicknameOf(player) ?? nameText(name);
}
